/**
 * 発送明細のシリアル番号を「台数分の欄」で扱うための関数。
 *
 * 発送の自動作成 (onPurchaseOrderShipped) は 2026-10-29 まで serialNumbers を空配列で作っていた。
 * 配列の長さで数えると「0/0 = 入力済み」と判定され、シリアル入力欄が出ず、
 * シリアルなしで納品完了にできてしまうため、件数は必ず台数 (quantity) を基準にする。
 *
 * 2026-10-30〜: deviceKind='none' (ソフト・アップグレード等、機器ではない行) は欄を持たず件数にも数えない。
 */
import type { DeliveryLineItem } from '../types/delivery';

type SerialLine = Pick<DeliveryLineItem, 'quantity' | 'serialNumbers'> &
  Partial<Pick<DeliveryLineItem, 'deviceKind'>>;

function slotCount(item: SerialLine): number {
  if (item.deviceKind === 'none') return 0;
  const qty = Math.max(0, Math.floor(Number(item.quantity) || 0));
  return Math.max(qty, item.serialNumbers?.length ?? 0);
}

/** 台数分の欄にそろえたシリアル番号 (未入力は空文字)。台数より多く入っている分は残す。 */
export function padSerialNumbers(item: SerialLine): string[] {
  const serials = item.serialNumbers ?? [];
  return Array.from({ length: slotCount(item) }, (_, i) => serials[i] ?? '');
}

/** 発送 1 件のシリアル入力状況 (台数基準)。 */
export function countDeliverySerials(lineItems: SerialLine[]): {
  total: number;
  filled: number;
  missing: number;
} {
  let total = 0;
  let filled = 0;
  for (const item of lineItems) {
    const slots = padSerialNumbers(item);
    total += slots.length;
    filled += slots.filter((s) => s.trim().length > 0).length;
  }
  return { total, filled, missing: total - filled };
}
